import React, {Component, Fragment} from 'react';
import contact from "../../consumers/contact";
import PageTitle from "../components/PageTitle";
import ContactForm from '../components/ContactForm';
import SocialNetworks from "../components/SocialNetworks";

class Contact extends Component {

    constructor(props) {
        super(props);
        this.state = {
            send: false
        };
        this.callback = this.callback.bind(this);
    }

    callback(message) {
        const reference = this.props.reference;
        reference.push().set(message);
        this.setState({send:true});
    }

    render() {
        const rigthCol = (!this.state.send) ? <ContactForm callback={this.callback}/> : <h3 className="text-center">Gracias :)</h3>;
        return (
            <Fragment>
                <PageTitle title={"Contacto"}/>
                <section className="bg-light py-13 px-7">
                    <div className="container p-0">
                        <div className="row no-gutters">

                            <div className="col-md-6">

                                <h5><a href="mailto:cutiko@gmail.om.com" target="_blank" rel="noopener noreferrer">cutiko@gmail.com</a></h5>

                                <p className="small serif my-5">Puedes enviarme un correo directo o escribirme usando el formulario, gracias</p>

                                <p className="small serif text-links mt-5">
                                    <SocialNetworks/>
                                </p>

                            </div>

                            <div className="col-md-6">

                                {rigthCol}

                            </div>

                        </div>
                    </div>
                </section>
            </Fragment>
        );
    }

}


export default contact(Contact);


// WEBPACK FOOTER //
// ./src/visitors/publishers/Contact.js